import React from 'react';
import { connect } from 'react-redux';
import { withComponentName } from '../../../common/ComponentNameContext';
import { SearchFilter } from '../../../common/search-filter';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import {
  changeCurrentSearch,
  fetchDataSnapshotSearch,
  REDUCER_NAME,
} from '../reducer';
import './searchbox.scss';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../../app/commonReducer';

class SearchBox extends React.Component {
  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCurrentSearch, componentId } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      data.search.isIndex ||
      data.search.isDerivatives ||
      !data.search.isTicker
    ) {
      return;
    }
    changeCurrentSearch(data.search, componentId);
  };

  clickItemSearch = code => {
    const {
      changeCurrentSearch,
      componentId,
      syncType,
      fetchDataSnapshotSearch,
    } = this.props;

    changeCurrentSearch(code, componentId);
    fetchDataSnapshotSearch(code, componentId);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: code,
    });
  };

  render() {
    let {
      currentSearch: tmpCurrentSearch,
      listOrganizationByOrganCode,
    } = this.props;

    const currentSearch =
      listOrganizationByOrganCode[tmpCurrentSearch.code] || tmpCurrentSearch;

    return (
      <SearchFilter
        schema={[
          { key: 'displayCode', className: 'w-20' },
          { key: 'codeName', className: 'w-55 text-truncate' },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => text.toUpperCase(),
          },
        ]}
        listKeyFilter={['displayCode', 'codeName']}
        getListSearchFromRedux={state =>
          state[COMMON_REDUCER_NAME].listOrganizationSearch
        }
        clickItemSearch={this.clickItemSearch}
        currentSearch={currentSearch}
        mainKey={'code'}
        sortKey={'displayCode'}
        customWidth={170}
      />
    );
  }
}

const mapDispatchToProps = {
  changeCurrentSearch,
  fetchDataSnapshotSearch,
};

const mapStateToProps = (state, { componentId, componentName }) => ({
  componentId,
  currentSearch:
    state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
